export const STOPPED_ITEM_COPY = "Stopped by user.";
